import { connect } from "react-redux";
import Uebersicht from "./Uebersicht";

import { hasAnyAccessory } from "../model/Zubehoer";

export default connect(state => ({
	hasAnyAccessory: hasAnyAccessory(state)
}))(Uebersicht);
